// extracted by mini-css-extract-plugin
export var pillWrapper = "_mi-0";
export var showOverflow = "_mi-1";